// Lib
import React from 'react';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';

// Components
import InlineBoardLinkInitialContent from './InlineBoardLinkInitialContent';
import InlineBoardLinkResolvedContent from './InlineBoardLinkResolvedContent';

// Constants
import { InlineBoardLinkStatus } from './inlineBoardLinkConstants';

const InlineBoardLinkContentSwitch = (props: NodeViewProps) => {
    const { node } = props;
    const { status } = node.attrs;

    switch (status) {
        case InlineBoardLinkStatus.initial:
            return <InlineBoardLinkInitialContent {...props} />;
        case InlineBoardLinkStatus.resolved:
            return <InlineBoardLinkResolvedContent {...props} />;
        default:
            return null;
    }
};

const InlineBoardLinkNodeView = (props: NodeViewProps) => (
    <NodeViewWrapper as="span" className="inline-board-link">
        <InlineBoardLinkContentSwitch {...props} />
    </NodeViewWrapper>
);

export default InlineBoardLinkNodeView;
